import { fork } from 'redux-saga/effects';

export default function* saga(persistor) {
 const fullAppSaga = require('./full-app').default;
 yield fork(fullAppSaga);
}